import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "row gap-04" }
const _hoisted_3 = { class: "mtop-20 w-full" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "mleft-06" }
const _hoisted_6 = { class: "mtop-04" }
const _hoisted_7 = { class: "row mtop-20" }
const _hoisted_8 = { class: "mleft-06" }
const _hoisted_9 = { class: "row mtop-03" }

import { ref, watch} from 'vue';
import { useI18n } from 'vue-i18n';
import gen from '@/functions/general.js';
import { FinancialGroupReminderSettings } from '@/apiGenerate/medserver';


export default /*@__PURE__*/_defineComponent({
  __name: 'editReminderSettings',
  props: {
    financialGroup: {},
    reminderLevel: {},
    reminderSettings: {}
  },
  emits: ['settingsChanged'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const currentLevel = ref(props.reminderLevel);

const msgToPatient = ref("");
const titleToPatient = ref("");
const msgToPatientSelected = ref(true);
const feeSelected = ref(false);
const feeLabel = ref("");
const reminderFee = ref("");

// Local copy of settings that stays in sync
const localSettings = ref<FinancialGroupReminderSettings | null>(null);

function loadSettingsForLevel(level: number) {
  const settings = localSettings.value;
  if (!settings) return;
  
  if (level === 1) {
    msgToPatient.value = settings.reminderText1;
    titleToPatient.value = settings.reminderTitle1;
    feeLabel.value = settings.reminderFeeLabel1;
    reminderFee.value = settings.reminderFee1;
    msgToPatientSelected.value = settings.hasCreateReminderDocument1;
    feeSelected.value = settings.hasCreateReminderBill1;
  } else if (level === 2) {
    msgToPatient.value = settings.reminderText2;
    titleToPatient.value = settings.reminderTitle2;
    feeLabel.value = settings.reminderFeeLabel2;
    reminderFee.value = settings.reminderFee2;
    msgToPatientSelected.value = settings.hasCreateReminderDocument2;
    feeSelected.value = settings.hasCreateReminderBill2;
  } else if (level === 3) {
    msgToPatient.value = settings.reminderText3;
    titleToPatient.value = settings.reminderTitle3;
    feeLabel.value = settings.reminderFeeLabel3;
    reminderFee.value = settings.reminderFee3;
    msgToPatientSelected.value = settings.hasCreateReminderDocument3;
    feeSelected.value = settings.hasCreateReminderBill3;
  }
}

watch(
  () => props.reminderSettings,
  (settings) => {
    if (settings) {
      localSettings.value = { ...settings };
      loadSettingsForLevel(currentLevel.value);
    }
  },
  { immediate: true }
);

const emits = __emit;

function saveCurrentLevelToLocalSettings() {
  if (!localSettings.value) return;

  const level = currentLevel.value;
  
  if (level === 1) {
    localSettings.value.reminderText1 = msgToPatient.value;
    localSettings.value.reminderTitle1 = titleToPatient.value;
    localSettings.value.reminderFeeLabel1 = feeLabel.value;
    localSettings.value.reminderFee1 = reminderFee.value;
    localSettings.value.hasCreateReminderDocument1 = msgToPatientSelected.value;
    localSettings.value.hasCreateReminderBill1 = feeSelected.value;
  } else if (level === 2) {
    localSettings.value.reminderText2 = msgToPatient.value;
    localSettings.value.reminderTitle2 = titleToPatient.value;
    localSettings.value.reminderFeeLabel2 = feeLabel.value;
    localSettings.value.reminderFee2 = reminderFee.value;
    localSettings.value.hasCreateReminderDocument2 = msgToPatientSelected.value;
    localSettings.value.hasCreateReminderBill2 = feeSelected.value;
  } else if (level === 3) {
    localSettings.value.reminderText3 = msgToPatient.value;
    localSettings.value.reminderTitle3 = titleToPatient.value;
    localSettings.value.reminderFeeLabel3 = feeLabel.value;
    localSettings.value.reminderFee3 = reminderFee.value;
    localSettings.value.hasCreateReminderDocument3 = msgToPatientSelected.value;
    localSettings.value.hasCreateReminderBill3 = feeSelected.value;
  }
}

function switchToLevel(level: number) {
  if (level === currentLevel.value) return;
  // Save current level's changes to local settings first
  saveCurrentLevelToLocalSettings();
  // Emit the updated settings
  emits('settingsChanged', { ...localSettings.value });
  // Switch to new level
  currentLevel.value = level;
  loadSettingsForLevel(level);
}

watch([msgToPatient, titleToPatient, feeLabel, reminderFee, msgToPatientSelected, feeSelected], () => {
  saveCurrentLevelToLocalSettings();
  emits('settingsChanged', { ...localSettings.value });
});


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal row w-maxC gap-30",
    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('accounting.invoiceReminder.reminderSettings.title', {sequence: currentLevel.value}),
          styles: "font-l"
        }, null, 8, ["txt"]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mleft-04" }, null, -1)),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (level) => {
          return _createVNode(_component_switchGroup, {
            key: level,
            active: currentLevel.value === level,
            class: "psides-15",
            onClick: ($event: any) => (switchToLevel(level))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)('accounting.invoiceReminder.reminder', {sequence: level}),
                styles: "main-m",
                class: _normalizeClass(currentLevel.value === level ? 'txt-white' : '')
              }, null, 8, ["txt", "class"])
            ]),
            _: 2
          }, 1032, ["active", "onClick"])
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('accounting.invoiceReminder.letter'),
            styles: "font-mBold",
            class: "pad-s"
          }, null, 8, ["txt"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_switchGroup, {
              active: msgToPatientSelected.value,
              class: "psides-10",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (msgToPatientSelected.value = !msgToPatientSelected.value))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "check",
                  styles: "size-m",
                  class: _normalizeClass(msgToPatientSelected.value ? 'img-white' : '')
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["active"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_inputBox, { style: {"width":"19.4rem"} }, {
            default: _withCtx(() => [
              _createVNode(_component_inputLineNew2, {
                modelValue: titleToPatient.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((titleToPatient).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_inputBox, { class: "mtop-04" }, {
          default: _withCtx(() => [
            _createVNode(_component_inputAreaAuto2, {
              lines: 14,
              modelValue: msgToPatient.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((msgToPatient).value = $event)),
              placeholder: "",
              style: {"width":"42rem"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('accounting.invoiceReminder.fee'),
            styles: "font-mBold",
            class: "pad-s"
          }, null, 8, ["txt"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_switchGroup, {
              active: feeSelected.value,
              class: "psides-10 mleft-auto",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (feeSelected.value = !feeSelected.value))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "check",
                  styles: "size-m",
                  class: _normalizeClass(feeSelected.value ? 'img-white' : '')
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["active"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_inputBox, { style: {"width":"19.4rem"} }, {
            default: _withCtx(() => [
              _createVNode(_component_inputLineNew2, {
                modelValue: feeLabel.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((feeLabel).value = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_inputBox, {
            style: {"width":"4rem"},
            class: "mleft-06"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_inputLineNew2, {
                modelValue: reminderFee.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((reminderFee).value = $event)),
                onKeydown: _unref(gen).onlyNumber,
                onPaste: _unref(gen).onlyNumber
              }, null, 8, ["modelValue", "onKeydown", "onPaste"])
            ]),
            _: 1
          }),
          _createVNode(_component_text_item, {
            txt: " €",
            styles: "main-m",
            class: "mleft-04"
          })
        ])
      ])
    ])
  ]))
}
}

})